module.exports = __webpack_public_path__ + "static/media/red-plus.svg";